import { createAction } from 'redux-act';

export class TopicsActions {
  public static selectTopic = createAction<number>();

  public static closeTopic = createAction();
}
